<template>
  <div id="cat" v-cloak>
    <div class="vx-card">
      <div class="vx-card__body card-body">
        <create-popup
          :parent="parent"
          :show="showCreatePermission"
          @finish="onfinish"
          @close="showCreatePermission = false"
        ></create-popup>
        <modify-popup
          :show="showModifyPermission"
          :modifySelected="modifySelected"
          @finish="onfinish"
          @close="showModifyPermission = false"
        ></modify-popup>
        <tree-children
          ref="grid"
          stripe
          :data-source="gridDataSource"
          @createPermissionInTree="createPermission"
        >
          <template slot-scope="{ row }">
            <td
              style="width: 10%"
              class="test44"
              @click="row.isActive = !row.isActive"
            >
              {{ row.isActive ? "فعال" : "غیرفعال" }}
            </td>

            <td style="width: 10%">
              <div
                class="flex gap-1 gap-x-2 justify-center items-center flex-wrap"
              >
                <vs-button
                  color="success"
                  type="gradient"
                  size="small"
                  icon-pack="feather"
                  icon="icon-plus"
                  class="d-inline mx-0"
                  @click.prevent="createPermission(row)"
                  v-has-permission="permission164"
                ></vs-button>
                <vs-button
                  color="primary"
                  type="gradient"
                  size="small"
                  icon-pack="feather"
                  icon="icon-edit"
                  class="d-inline"
                  @click.prevent="editPermission(row)"
                  v-has-permission="permission163"
                ></vs-button>
                <vs-button
                  radius
                  color="danger"
                  size="small"
                  type="gradient"
                  icon-pack="feather"
                  icon="icon-x"
                  @click.prevent="deletePermission(row.id)"
                  class="d-inline"
                  v-has-permission="permission162"
                ></vs-button>
              </div>
            </td>
          </template>
        </tree-children>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.test44:hover {
  background-color: #007470;
  color: white;
}
</style>

<script>
import TreeChildren from "@/components/treechildren/TreeChildren";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import ModifyPopup from "./ModifyPopup.vue";
import CreatePopup from "./CreatePopup.vue";
import { mapActions } from "vuex";

export default {
  name: "saleManagement_BasicDefinitions_productSegment_ProductPopup",
  components: {
    ModifyPopup,
    CreatePopup,
    TreeChildren,
  },
  data() {
    return {
      permission162: "DeletePermission",
      permission163: "ModifyPermission",
      permission164: "CreatePermission",
      gridDataSource: {
        type: "app",
        service: "IdentityAccess/api/PermissionsQuery",
      },
      gridSearchData: {},
      showCreatePermission: false,
      showModifyPermission: false,
      showdeletePermission: false,
      parentId: "",
      parent: {},
      modifySelected: {},
    };
  },
  computed: {
    showModal: {
      get: function () {
        return this.show;
      },
      set: function () {
        this.$emit("finish");
      },
    },
  },
  methods: {
    ...mapActions({
      deletePermissionApi: "permission/remove",
    }),
    createPermission(parent = "") {
      this.showCreatePermission = true;
      this.parent = parent;
    },
    onfinish(name) {
      this.showCreatePermission = false;
      this.showModifyPermission = false;
      const renderConfig = { showOverlayLoading: true, searchKeyword: name };
      this.$refs.grid.renderGrid(renderConfig);
    },
    editPermission(modifySelected) {
      this.showModifyPermission = true;
      this.modifySelected = { ...modifySelected };
    },
    deletePermission(deleteSelected) {
      this.$swal({
        title: "آیا از حذف این رکورد اطمینان دارید؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بلی",
        cancelButtonText: "خیر",
      }).then((result) => {
        if (result.value) {
          this.deletePermissionApi(deleteSelected).then(() => {
            this.$swal({
              position: "center-center",
              type: "success",
              text: "رکورد مورد نظر با موفقیت حذف شد",
              showConfirmButton: false,
              timer: 2000,
            });
            const renderConfig = { showOverlayLoading: true };
            this.$refs.grid.renderGrid(renderConfig);
          });
        }
      });
    },
  },
};
</script>
